import React from 'react';

import bannerBg from '../../assets/images/builders/bannerBg.jpg'
function BuilderBanner() {

  return (
    <>
        <div className="builderPageBanner">
            <img src={bannerBg} alt="" />
            <div className="builderPageBannerDetails">
                <h1>Explore Trusted Builders in Kerala</h1>
                <p>Discover a curated list of trusted builders in Kerala. Explore their projects, expertise, and offerings to find the perfect partner for your dream property.</p>
            </div>
        </div>
    </>
  );
}

export default BuilderBanner;
